import { render, staticRenderFns } from "./FinetuneSuggestionList.vue?vue&type=template&id=55128840&scoped=true&"
import script from "./FinetuneSuggestionList.vue?vue&type=script&lang=js&"
export * from "./FinetuneSuggestionList.vue?vue&type=script&lang=js&"
import style0 from "./FinetuneSuggestionList.vue?vue&type=style&index=0&id=55128840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55128840",
  null
  
)

export default component.exports